import axios from "axios";
import React, { useState, useEffect } from "react";
import { Form, Table, Modal } from "react-bootstrap";
import { environment } from "../../../environment";
import { LinkContainer } from "react-router-bootstrap";
import Swal from "sweetalert2";
import { Button } from "react-bootstrap";
import withReactContent from "sweetalert2-react-content";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import {
  PaginationListStandalone,
  PaginationProvider,
  PaginationTotalStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import Toggle from "react-toggle";
import NavbarNew from "../../Components/NavbarNew";

const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const LeadExecutiveIndex = ({ history, match }) => {
  const [lead_executives, setLeadExecutives] = useState([]);
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
  };
  const [executivedetails, setexecutivedetails] = useState({});

  const fetchLeadExecutives = () => {
    axios
      .get(environment.dap_url + "crm_api/getAllLeadExecutive")
      .then((res) => {
        try {
          const partnerDetails = JSON.parse(
            localStorage.getItem("userDetails")
          );
          if (partnerDetails.data.authority === "PARTNER") {
            const onlyForPartner = res.data.filter(
              (item) => item.createdBy === partnerDetails.data.id.id
            );
            setLeadExecutives(onlyForPartner);
          } else {
            setLeadExecutives(res.data);
          }
        } catch (error) {
          setLeadExecutives(res.data);
          console.log(error);
        }
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  };
  useEffect(() => {
    fetchLeadExecutives();
  }, []);
  const formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };
  const getleadExecutiveDetail = (_id) => {
    axios
      .get(environment.dap_url + "crm_api/getLeadExecutiveById?id=" + _id)
      .then((res) => {
        setexecutivedetails(res.data);
        handleShow();
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  };
  const deleteHandler = (_id) => {
    // alert(_id);
    // console.log(id);
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.isConfirmed) {
        axios
          .delete(environment.dap_url + "crm_api/deleteLeadExecutive?id=" + _id)
          .then((res) => {
            MySwal.fire({
              title: <p>Lead Executive has been successfully deleted!</p>,
              type: "success",
            });
            fetchLeadExecutives();
          })

          .catch((err) => {
            MySwal.fire({
              title: (
                <p>{err?.response?.data?.message || "User  deletion failed"}</p>
              ),
              type: "error",
            });
          });
      }
    });
  };

  function CustomToggle({ checked, onChange }) {
    return <Toggle checked={checked} onChange={onChange} />;
  }
  // const [data, setData] = useState([]);

  const handleToggle = async (_id) => {
    const apiResponse = await axios.get(
      environment.dap_url + "crm_api/checkActiveInactive?id=" + _id
    );
    console.log(apiResponse);
    const status = apiResponse.data.status;
    const action = status ? "deactivate" : "activate";

    const result = await Swal.fire({
      title: `Are you sure you want to ${action} this feature?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });
    if (result.isConfirmed) {
      axios
        .put(environment.dap_url + "users/toggleStatus?id=" + _id)
        .then(async (resp) => {
          if (resp.status == 200) {
            setLeadExecutives([]);
            const response = await axios.get(
              environment.dap_url + "crm_api/getAllLeadExecutive"
            );
            console.log(response.data);
            setLeadExecutives(response.data);
          }
        });
    }
  };

  const columns = [
    {
      dataField: "id",
      text: "#",
      formatter: (_, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "id",
      text: "Name",
      sort: true,
      formatter: function (_, row, rowIndex, formatExtraData) {
        // console.log(cell);
        return row.userFirstName + " " + row.userLastName;
        // return dataField;
        // return
      },
    },
    {
      dataField: "email",
      text: "Email",
      sort: false,
    },
    {
      dataField: "phone",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "city",
      text: "City",
      sort: true,
    },
    {
      dataField: "isActive",
      text: "Active",
      sort: false,
      formatter: (_, row, rowIndex, formatExtraData) => {
        return (
          <CustomToggle
            checked={row.isActive}
            onChange={(e) => handleToggle(row._id)}
          />
        );
      },
    },
    {
      dataField: "userType",
      text: "Partner",
      sort: false,
      formatter: (_, row, rowIndex, formatExtraData) => {
        if (row.parent_details.length > 0) {
          return (
            row.parent_details[0].userFirstName +
            " " +
            row.parent_details[0].userLastName
          );
        }
        return "";
      },
    },
    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        return (
          <div>
            <Button
              variant="primary"
              className="btn-sm"
              onClick={() => getleadExecutiveDetail(dataField)}
            >
              <i className="fa fa-eye"></i>
            </Button>

            <LinkContainer to={`/lead-executives/edit/` + dataField}>
              <Button variant="info" className="btn-sm">
                <i className="fa fa-edit"></i>
              </Button>
            </LinkContainer>

            <Button
              variant="danger"
              className="btn-sm"
              onClick={() => deleteHandler(dataField)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          </div>
        );
      },
    },
  ];
  const defaultSorted = [
    {
      dataField: "createdAt",
      order: "asc",
    },
  ];
  const pageButtonRenderer = ({
    page,
    active,
    disabled,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      // console.log(page);
      onPageChange(page);
    };
    return (
      <li className="page-item">
        <Button onClick={handleClick}>{page}</Button>
      </li>
    );
  };

  const option = {
    custom: true,
    totalSize: lead_executives.length,
  };
  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {executivedetails.userFirstName +
              " " +
              executivedetails.userLastName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th width="50%" scope="row">
                  Name
                </th>
                <td>
                  {executivedetails.userFirstName +
                    " " +
                    executivedetails.userLastName}
                </td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Email
                </th>
                <td>{executivedetails.email}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  DOB
                </th>
                <td>{executivedetails.DOB}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Phone
                </th>
                <td>{executivedetails.phone}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Country
                </th>
                <td>{executivedetails.country}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  State
                </th>
                <td>{executivedetails.state}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  City
                </th>
                <td>{executivedetails.city}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  zip
                </th>
                <td>{executivedetails.zip}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Address
                </th>
                <td>{executivedetails.address}</td>
              </tr>
              <tr>
                <th width="50%" scope="row">
                  Created_On
                </th>
                <td>{formatDate(executivedetails.createdAt)}</td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="container-fluid">
        <NavbarNew />
        <h4 className="card-title">LEAD EXECUTIVES</h4>
        <ToolkitProvider
          keyField="_id"
          bootstrap4
          data={lead_executives}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <div className="d-flex align-items-center">
                <p className="mb-2 mr-2">Search in table:</p>
                <SearchBar {...props.searchProps} />
              </div>
              <BootstrapTable
                defaultSorted={defaultSorted}
                pagination={paginationFactory()}
                data={lead_executives}
                columns={columns}
                {...props.baseProps}
                wrapperClasses="table-responsive"
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
    </>
  );
};

export default LeadExecutiveIndex;
